import axios from 'axios';
import { AppConfig } from '@/config';

/** Sign-in endpoints that live outside the authenticated clients. */

export interface DevLoginRequest {
  username: string;
  password: string;
}

export type DevLoginResult =
  | { success: true; token: string }
  | { success: false; status?: number };

/**
 * POST {VITE_API_BASE_URL}/auth/dev-login with plain axios: no stored token
 * exists yet, so the authenticated clients and their interceptors are not
 * involved.
 */
export const devLogin = async (
  credentials: DevLoginRequest,
): Promise<DevLoginResult> => {
  try {
    const response = await axios.post<{ token: string }>(
      AppConfig.devLogin.endpoint,
      credentials,
    );
    return { success: true, token: response.data.token };
  } catch (requestError) {
    const status = axios.isAxiosError(requestError)
      ? requestError.response?.status
      : undefined;
    return { success: false, status };
  }
};
